import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useT } from '~app/core/BundleProvider';
import withEnterToClick from '~app/core/withEnterToClick';
import Table from '~app/features/app/components/Table';
import { actions as SaveLoadActions } from '~app/features/saveLoad';

const ClickOrEnterDiv = withEnterToClick('div');

// lat step to display student results
const ResultsPage = ({
  ResultsTableRow,
  tableColumns,
  filterData,
  setCurrentPage,
}) => {
  const t = useT();
  const dispatch = useDispatch();
  const getKey = row => row.uuid;
  const doc = useSelector(state => state.document);
  const grading = useSelector(state => state.grading);
  const download = () => {
    dispatch(
      SaveLoadActions.exportGrades({
        csv: SaveLoadActions.ConvertJSONToCSV(grading.gradingResults),
        baseName: doc.present?.name,
        imageBlobs: grading.markedScreenshots,
        timestamp: SaveLoadActions.getTimeStamp(),
      }),
    );
  };
  const handleBackButtonClick = useCallback(
    e => {
      setCurrentPage(2);
    },
    [setCurrentPage],
  );

  return (
    <>
      <div className="Progress__button-container">
        <div>
          <ClickOrEnterDiv
            key={t('back') ?? t('back')}
            className="Back__button"
            onClick={handleBackButtonClick}
            role="button"
            aria-label={t('back')}
            tabIndex="0"
          >
            {t('back')}
          </ClickOrEnterDiv>
        </div>
        <div className="Progress_button-downloadWrap">
          <ClickOrEnterDiv
            key={t('download-results') ?? t('download-results')}
            className="Progress__button"
            onClick={download}
            role="button"
            aria-label={t('download-results')}
            tabIndex="0"
          >
            {t('download-results')}
          </ClickOrEnterDiv>
          <div>{t('results-warning')}</div>
        </div>
      </div>
      <div className="Table__container Table__container-results">
        <Table
          TableRow={ResultsTableRow}
          tableColumns={tableColumns}
          data={grading.gradingResults.slice(1)}
          title={t('results')}
          filterData={filterData}
          defaultSort="Personal_Identifier"
          getKey={getKey}
        />
      </div>
    </>
  );
};

export default ResultsPage;
